// Redux Phases module
// see https://github.com/erikras/ducks-modular-redux

import { Phases } from '../../services';
import { createRestSlices, applyReducers } from './rest';

const {
    initialState,
    getReducer, listReducer, updateReducer, duplicateReducer,
    startCreateReducer, createReducer, deleteReducer,
    getAction, listAction, updateAction, duplicateAction,
    startCreateAction, createAction, deleteAction,
    linkedResourcesReducer, linkedResourcesAction
} = createRestSlices(Phases);

/* Export reducer */
export default (state = initialState, action) => {
    return applyReducers(state, action, [
        getReducer, listReducer, updateReducer, duplicateReducer,
        startCreateReducer, createReducer, deleteReducer,
        linkedResourcesReducer
    ]);
}

/* Export CRUD actions */
export const startCreatePhase         = startCreateAction;
export const createPhase              = createAction;
export const loadPhase                = getAction;
export const loadPhases               = listAction;
export const updatePhase              = updateAction;
export const deletePhase              = deleteAction;
export const duplicatePhase           = duplicateAction;
export const getPhasesLinkedResources = linkedResourcesAction;
